interface PluginRenewalCopyInput {
    isPluginProduct: boolean;
    subscriptionStatus?: string | null;
    actionLabel?: string | null;
}

const normalize = (value?: string | null): string => (value || '').trim().toLowerCase();

/**
 * A Plugin subscription that is ending can still be resumed for its next
 * billing period. Its CTA must describe restoring auto-renewal rather than
 * implying an immediate, separate charge.
 */
export const shouldUsePluginRestoreAutoRenewalCopy = ({
    isPluginProduct,
    subscriptionStatus,
    actionLabel,
}: PluginRenewalCopyInput): boolean => {
    if (!isPluginProduct) return false;

    const status = normalize(subscriptionStatus);
    return status === 'canceled'
        || status === 'pending_cancellation'
        || normalize(actionLabel) === 'renew';
};
